export const INPUT_TEXT_MAX_CHARS = 50
export const EMAIL_MAX_CHARS = 255
